import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class User extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            password: '',
        };
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/user/get", {
            id: this.getCurrentFormId(),
            type: 1
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/user/save", {
            id: this.state.id,
            fname: this.state.data.record.fname,
            lname: this.state.data.record.lname,
            mobile: this.state.data.record.mobile,
            password: this.state.password,
            status: this.state.data.record.status,
            role: this.state.data.record.role,
            permissions: this.state.data.record.permissions
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setRole(e) {
        this.state.data.record.role = e;
        this.setState({ data: this.state.data });
    }
    getPermision(p) {
        if (this.state.data.record.permissions.includes('[' + p + ']')) return true;
        return false;
    }
    setPermision(p,e) {
        this.state.data.record.permissions = this.state.data.record.permissions.replace('[' + p + ']', '');
        if (e)
            this.state.data.record.permissions += '[' + p + ']';
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات کاربر" : "افزودن کاربر جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">نام</label>
                                            <div className="form-control-wrap">
                                                <input className="form-control" type="text" defaultValue={this.state.data.record.fname} onChange={e => this.state.data.record.fname = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">نام خانوادگی</label>
                                            <div className="form-control-wrap">
                                                <input className="form-control" type="text" defaultValue={this.state.data.record.lname} onChange={e => this.state.data.record.lname = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">شماره موبایل</label>
                                            <div className="form-control-wrap">
                                                <input maxLength="13" className="form-control" type="text" defaultValue={this.state.data.record.mobile} onChange={e => this.state.data.record.mobile = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">وضعیت</label>
                                            <div className="form-control-wrap">
                                                <select className="form-control" type="text" defaultValue={this.state.data.record.status} onChange={e => this.state.data.record.status = parseInt(e.target.value)}>
                                                    <option value='1'>تایید شده</option>
                                                    <option value='2'>مسدود شده</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">نقش</label>
                                            <div className="form-control-wrap">
                                                <select className="form-control" type="text" defaultValue={this.state.data.record.role} onChange={e => this.setRole(parseInt(e.target.value))}>
                                                    <option value='1'>مدیر</option>
                                                    <option value='2'>تنظیمات</option>
                                                    <option value='3'>شناسنامه سنگ</option>
                                                    <option value='4'>شناسنامه فاخر</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">کلمه عبور</label>
                                            <div className="form-control-wrap">
                                                <input className="form-control" type="password" defaultValue={this.state.password} onChange={e => this.state.password = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.data.record.role !== 1 && <div className="row mt-4">
                                    <div className="col-lg-1">
                                        <div className="form-group">
                                            <label className="form-label"><input type="checkbox" defaultChecked={this.getPermision('applicants')} onChange={e => this.setPermision('applicants', e.target.checked)} /> مشتریان</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-1">
                                        <div className="form-group">
                                            <label className="form-label"><input type="checkbox" defaultChecked={this.getPermision('requests')} onChange={e => this.setPermision('requests', e.target.checked)} /> درخواستها</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-1">
                                        <div className="form-group">
                                            <label className="form-label"><input type="checkbox" defaultChecked={this.getPermision('templates')} onChange={e => this.setPermision('templates', e.target.checked)} /> الگوها</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-1">
                                        <div className="form-group">
                                            <label className="form-label"><input type="checkbox" defaultChecked={this.getPermision('colors')} onChange={e => this.setPermision('colors', e.target.checked)} /> رنگها</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-1">
                                        <div className="form-group">
                                            <label className="form-label"><input type="checkbox" defaultChecked={this.getPermision('sizes')} onChange={e => this.setPermision('sizes', e.target.checked)} /> ابعاد</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-1">
                                        <div className="form-group">
                                            <label className="form-label"><input type="checkbox" defaultChecked={this.getPermision('weights')} onChange={e => this.setPermision('weights', e.target.checked)} /> وزنها</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-1">
                                        <div className="form-group">
                                            <label className="form-label"><input type="checkbox" defaultChecked={this.getPermision('kinds')} onChange={e => this.setPermision('kinds', e.target.checked)} /> انواع تراش</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-1">
                                        <div className="form-group">
                                            <label className="form-label"><input type="checkbox" defaultChecked={this.getPermision('types')} onChange={e => this.setPermision('types', e.target.checked)} /> انواع سنگ</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-1">
                                        <div className="form-group">
                                            <label className="form-label"><input type="checkbox" defaultChecked={this.getPermision('stufftypes')} onChange={e => this.setPermision('stufftypes', e.target.checked)} /> انواع کالاها</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-1">
                                        <div className="form-group">
                                            <label className="form-label"><input type="checkbox" defaultChecked={this.getPermision('jenses')} onChange={e => this.setPermision('jenses', e.target.checked)} />جنس کالاها</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-1">
                                        <div className="form-group">
                                            <label className="form-label"><input type="checkbox" defaultChecked={this.getPermision('rings')} onChange={e => this.setPermision('rings', e.target.checked)} /> سایز رینگ</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-1">
                                        <div className="form-group">
                                            <label className="form-label"><input type="checkbox" defaultChecked={this.getPermision('websites')} onChange={e => this.setPermision('websites', e.target.checked)} /> وبسایتها</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-1">
                                        <div className="form-group">
                                            <label className="form-label"><input type="checkbox" defaultChecked={this.getPermision('users')} onChange={e => this.setPermision('users', e.target.checked)} /> کاربران</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-1">
                                        <div className="form-group">
                                            <label className="form-label"><input type="checkbox" defaultChecked={this.getPermision('settings')} onChange={e => this.setPermision('settings', e.target.checked)} /> تنظیمات</label>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}